import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import Card from '@/components/ui/cards/Card';
import { updateAdminPasswordService } from '@/services/AdminServices';

export default function SecurityTab({ adminId }) {
  const dispatch = useDispatch();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');

  const handleSave = () => {
    if (!password || password !== confirm) {
      return Swal.fire('Error', 'Passwords must match', 'error');
    }

    dispatch(updateAdminPasswordService(adminId, {
      password,
      confirm_password: confirm,
    }))
      .then(() => {
        Swal.fire('Saved', 'Password updated', 'success');
        setPassword('');
        setConfirm('');
      })
      .catch(() => {
        Swal.fire('Error', 'Update failed', 'error');
      });
  };

  return (
    <Card className="rounded-xl border border-gray-200 bg-white px-6 pt-6 pb-6">
      {/* Icon + heading */}
      <div className="flex items-center gap-2 mb-4">
        <i className="lab lab-lock-line text-xl text-slate-700" />
        <h3 className="text-lg font-medium">Change Password</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm text-gray-500 mb-1">Password *</label>
          <input
            type="password"
            className="w-full p-2 border border-gray-200 rounded"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm text-gray-500 mb-1">
            Confirm Password *
          </label>
          <input
            type="password"
            className="w-full p-2 border border-gray-200 rounded"
            value={confirm}
            onChange={e => setConfirm(e.target.value)}
          />
        </div>
      </div>

      <button
        onClick={handleSave}
        className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-md
                   bg-blue-600 text-white hover:bg-blue-700 transition"
      >
        <i className="lab lab-save-line text-base" />
        Save
      </button>
    </Card>
  );
}
